import { render, staticRenderFns } from "./Postagens.vue?vue&type=template&id=876fd43e&scoped=true"
import script from "./Postagens.vue?vue&type=script&lang=js"
export * from "./Postagens.vue?vue&type=script&lang=js"
import style0 from "./Postagens.vue?vue&type=style&index=0&id=876fd43e&prod&lang=scss&scoped=true"
import style1 from "./Postagens.vue?vue&type=style&index=1&id=876fd43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876fd43e",
  null
  
)

export default component.exports